import axios from "axios"

import { generateToken } from "./function"

export const GTM_PROJECT_CATEGORY = "SEO Flights"

// Dates used by API Parameters
const TODAY = new Date()
const TOMORROW = new Date()
TOMORROW.setDate(TODAY.getDate() + 1)
const THREE_DAYS_FROM_TODAY = new Date()
THREE_DAYS_FROM_TODAY.setDate(TODAY.getDate() + 3)

const TOMORROW_YYYYMMDD =
  String(TOMORROW.getFullYear()) +
  "-" +
  String(TOMORROW.getMonth() + 1).padStart(2, "0") + // jan starts from 0
  "-" +
  String(TOMORROW.getDate()).padStart(2, "0")

const THREE_DAYS_FROM_TODAY_YYYYMMDD =
  String(THREE_DAYS_FROM_TODAY.getFullYear()) +
  "-" +
  String(THREE_DAYS_FROM_TODAY.getMonth() + 1).padStart(2, "0") + // jan starts from 0
  "-" +
  String(THREE_DAYS_FROM_TODAY.getDate()).padStart(2, "0")

const TOMORROW_MMDDYYY =
  String(TOMORROW.getMonth() + 1).padStart(2, "0") +
  "/" +
  String(TOMORROW.getDate()).padStart(2, "0") +
  "/" +
  String(TOMORROW.getFullYear())

const THREE_DAYS_FROM_TODAY_MMDDYYY =
  String(THREE_DAYS_FROM_TODAY.getMonth() + 1).padStart(2, "0") +
  "/" +
  String(THREE_DAYS_FROM_TODAY.getDate()).padStart(2, "0") +
  "/" +
  String(THREE_DAYS_FROM_TODAY.getFullYear())

export {
  TODAY,
  TOMORROW,
  THREE_DAYS_FROM_TODAY,
  TOMORROW_YYYYMMDD,
  THREE_DAYS_FROM_TODAY_YYYYMMDD,
  TOMORROW_MMDDYYY as TOMORROW_DDMMYYY,
  THREE_DAYS_FROM_TODAY_MMDDYYY as THREE_DAYS_FROM_TODAY_DDMMYYY,
}

// for Hotel API
export const HOTEL_API_TOKEN_CREDENTIALS = {
  clientId: "2891c285-3699-4d51-8f20-1888b5df37d4",
  iss_key: "0180c0dd-bdbe-477d-9a99-4adf16fe1f58",
  secret: "MJjgAI5EUPeOsP9LZY4rUw3T5uSq5bSIdJ8f6vGR9qs",
}

export const HOTEL_AUTOFILL_ENDPOINT =
  "https://hotelsbe.apiairasia.com/smartfill/v2/smartfill?query="
export const HOTEL_AUTOFILL_INSTANCE = axios.create({
  headers: {
    "Client-ID": HOTEL_API_TOKEN_CREDENTIALS.clientId,
    // Authorization: `Bearer ${generateToken()}`,
  },
})

export const HOTEL_SEARCH_ENDPOINT =
  "https://hotelsbe.apiairasia.com/search/v2/hotels"
export const HOTEL_SEARCH_INSTANCE = axios.create({
  headers: {
    "Client-ID": HOTEL_API_TOKEN_CREDENTIALS.clientId,
    // Authorization: `Bearer ${generateToken()}`,
  },
  params: {
    currency: "MYR",
    country_code: "MY",
    checkin:
      String(TODAY.getFullYear()) +
      "-" +
      String(TODAY.getMonth() + 1).padStart(2, "0") + // jan starts from 0
      "-" +
      String(TODAY.getDate()).padStart(2, "0"),
    checkout:
      String(TOMORROW.getFullYear()) +
      "-" +
      String(TOMORROW.getMonth() + 1).padStart(2, "0") + // jan starts from 0
      "-" +
      String(TOMORROW.getDate()).padStart(2, "0"), // checkout next day
    occupancy: "2",
    language: "en-US",
    hotels_size: 10,
  },
})

// for SNAP API
export const SNAP_BASE_ENDPOINT =
  process.env.GATSBY_ENV === "stg" || process.env.GATSBY_ENV === "dev"
    ? "https://snapweb.stgairasia.com"
    : "https://snapweb.airasia.com"

export const SNAP_TOKEN_ENDPOINT =
  SNAP_BASE_ENDPOINT + "/snap-auth/um/token"

export const SNAP_LISTING_ENDPOINT =
  SNAP_BASE_ENDPOINT + "/snap-services/hotels/list"

export const SNAP_TOKEN_INSTANCE =
  process.env.GATSBY_ENV === "stg" || process.env.GATSBY_ENV === "dev"
    ? axios.create({
        headers: {
          domainId: "c444b3fb-7d0b-47eb-951e-08c73df39f09",
          dId: "01",
        },
      })
    : axios.create({
        headers: {
          domainId: "a4c72f20-a361-4cc8-b5e4-f8b47df26755",
          dId: "01",
        },
      })



export const isLocalHost = process.env.GATSBY_ENV === "dev"
export const isStaging = process.env.GATSBY_ENV === "stg"

export const ZODIAC_BASE_PATH = isLocalHost ? "/zodiac-api" : isStaging ? "https://flights.stgairasia.com" : "https://flights.airasia.com";
export const HOTELS_BASE_PATH = isLocalHost ? "/hotels-api" : isStaging ? "https://hotelsbe-stg.apiairasia.com" : "https://hotelsbe.apiairasia.com";      
export const STATIC_FILE_PATH = isLocalHost ? "/static-file-api" : isStaging ? "https://static.stgairasia.com" : "https://static.airasia.com";
export const QR_POPUP_DATA_JSON_URI = isLocalHost || isStaging ? `https://static.stgairasia.com/affiliate/install/widget/flightseo/en-gb/file.json` : `https://static.airasia.com/affiliate/install/widget/flightseo/en-gb/file.json`

export const HOTELS_API_CREDS_DEV = {
  "clientId": "2ea88952-129e-4e3f-9907-7938eebbf620",
  "key": "506dd2c5-810b-435e-a576-5b470d4af1e1",
  "secret": "5VHr0P3RgHUcYCAJyeQvrS1APdDHEJtlpeNAY0CsD8Y"
};


export const HOTELS_API_CREDS_STG = {
  "clientId": "f27ba91e-ab41-4b69-8075-83c2e38c964b",
  "key": "75819606-f3ec-4247-a944-704bb4a2f98c",
  "secret": "WIxVzG2z1lPsNEjkeoQqZXLgEj3DrJjhEMNxpSEadfE"
}

export const HOTELS_API_CREDS_PROD = {
  "clientId": "2891c285-3699-4d51-8f20-1888b5df37d4",
  "key": "0180c0dd-bdbe-477d-9a99-4adf16fe1f58",
  "secret": "MJjgAI5EUPeOsP9LZY4rUw3T5uSq5bSIdJ8f6vGR9qs"
}

export const HOTELS_API_CREDS_SA_PROD = {
  "clientId": "2891c285-3699-4d51-8f20-1888b5df37d4",
  "key": "GksO2B8Uj4k1VHiUJ5vm4mVLwFQaEy3U",
  "secret": "Bbyqvr3NHYyxMYHVmgS9oG7ksEZiNLr4"
}

export const HOTELS_API_CREDS = isLocalHost ? HOTELS_API_CREDS_STG : isStaging ? HOTELS_API_CREDS_STG : HOTELS_API_CREDS_PROD;